import * as React from "react"
import * as NoMDT from "models/noMdt";
import { AppContext } from "AppContext";
import { ActionTypes } from "reducer/actions";
import { Box, Button, Typography } from "@mui/material";
import { FilterContext } from "models/core/filter";
import Select from "react-select";
import { exportMdtPatients } from "models/noMdt/worker";
import * as fileHelper from "helpers/fileHelper";
import Loader from "pages/shared/filterloader";

export function NoMdtFilters() {
	const { state, dispatch } = React.useContext(AppContext);

	const addFilter: NoMDT.AddFilterFunc = async (key: keyof typeof NoMDT.DashboardFilterKeys, value: string | string[], context?: FilterContext, labelOverride?: string) => {
		const filteredDashboard = await NoMDT.computeChartData(NoMDT.addFilter(state.page.dashboard as NoMDT.IMDTDashboard)(key, value, context, labelOverride)); // state = what the other filter function returns 
		dispatch({ type: ActionTypes.UserClickedOnChart, payload: filteredDashboard });
	}

	const removeFilter: NoMDT.RemoveFilterFunc = async (key: keyof typeof NoMDT.DashboardFilterKeys) => {

		const filteredDashboard = await NoMDT.computeChartData(NoMDT.removeFilter(state.page.dashboard as NoMDT.IMDTDashboard, key));
		dispatch({ type: ActionTypes.UserClickedOnChart, payload: filteredDashboard });
	}

	if (state.page.loading)
		return <Loader />;

	const noMDTData = state.page.dashboard.chartData as NoMDT.IChartData;

	//HHS 
	//HHS Options
	const hhsOptions: any[] = [];
	noMDTData?.hhses.map(p => {
		hhsOptions.push({ label: p.name, value: p.id });
	})

	//Filtered HHSes
	let hhsSelections: any[] = [];
	state.page.dashboard.filters?.HHS?.value?.map(p => {
		hhsSelections.push({ label: p, value: hhsOptions.find(a => a.label == p).value });
	})

	//Add code to be able to filter list of facilities to a chosen HHS
	let selectedHHSIds = [];
	if (hhsSelections.length > 0) {
		selectedHHSIds = hhsSelections.map(a =>
			a.value);
	}

	//Facility 
	//Facility Options
	const facilityOptions: any[] = [];
	if (hhsSelections.length > 0) {
		noMDTData?.facilities.filter(a => selectedHHSIds.includes(a.hhsId)).map(p => {
			facilityOptions.push({ label: p.name, value: p.facilityId });
		})
	} else {
		noMDTData?.facilities.map(p => {
			facilityOptions.push({ label: p.name, value: p.facilityId });
		});
	}

	//Filtered facilities
	let facilitySelections: any[] = [];
	state.page.dashboard.filters?.Facility?.value?.map(p => {
		facilitySelections.push({ label: p, value: facilityOptions.find(a => a.label == p).value });
	})

	let { path } = noMDTData.patientsByPeriod;
	let parts = FilterContext.fromPath(path).parts;

	//Months
	//Options
	const monthOptions: any[] = [];
	noMDTData?.month.map(p => {
		monthOptions.push({ label: p.name, value: p.id });
	})

	//Filtered MDT months
	let admMonthSelections: any[] = [];
	if (parts.length > 1) {
		parts[1].replace(`[`, ``).replace(`]`, ``).split('; ').map(p => {
			admMonthSelections.push({
				label: monthOptions.find(a => a.label.substring(0, 3) == p.replace(" ", ""))?.label,
				value: monthOptions.find(a => a.label.substring(0, 3) == p.replace(" ", ""))?.value
			});
		})
	}

	//Years
	//Admission year options
	const admYearOptions: any[] = [];
	noMDTData?.year.map(p => {
		if (p.id >= 2010 && p.name != "Unknown") {
			admYearOptions.push({ label: p.name, value: p.id });
		}
	})

	//Filtered year selections
	let admYearSelections: any[] = [];
	if (parts.length > 0) {
		parts[0].replace(`[`, ``).replace(`]`, ``).split(';').map(p => {
			admYearSelections.push({
				label: p.replace(" ", ""),
				value: noMDTData?.year.find(a => a.name == p.replace(" ", ""))?.id
			});
		})
	}

	return (
		<>
			<Box>
				<Typography>HHS</Typography>
				<Select
					isMulti={true}
					value={hhsSelections}
					options={hhsOptions}
					onChange={p => {
						const selected: any = p;
						let filterValues: string[] = [];
						selected.forEach(a => filterValues.push(a.label));

						if (filterValues.length == 0) {
							removeFilter(NoMDT.DashboardFilterKeys.HHS.key);
						} else {
							addFilter(NoMDT.DashboardFilterKeys.HHS.key, filterValues);
						}
					}}
					placeholder={"All"}
					closeMenuOnSelect={false}
					styles={{
						placeholder: (base) => ({
							...base,
							color: "black",
						}),
					}}
				/>
			</Box>


			<Box>
				<Typography>Facility</Typography>
				<Select
					isMulti={true}
					value={facilitySelections}
					options={facilityOptions}
					onChange={p => {
						const selected: any = p;
						let filterValues: string[] = [];
						selected.forEach(a => filterValues.push(a.label));

						if (filterValues.length == 0) {
							removeFilter(NoMDT.DashboardFilterKeys.Facility.key);
						} else {
							addFilter(NoMDT.DashboardFilterKeys.Facility.key, filterValues);
						}
					}}
					placeholder={"All"}
					closeMenuOnSelect={false}
					styles={{
						placeholder: (base) => ({
							...base,
							color: "black",
						}),
					}}
				/>
			</Box>

			<Box>
				<Typography>Admission Year</Typography>
				<Select
					isMulti={true}
					value={admYearSelections}
					options={admYearOptions.reverse()}
					onChange={p => {
						const selected: any = p;
						let filterValues: string[] = [];
						selected.forEach(a => filterValues.push(a.label));
						filterValues.sort();

						if (admYearSelections.length > 0) {
							let context = path && FilterContext.fromPath(path) || new FilterContext();
							context.parts = [];

							if (filterValues.length == 0) {
								removeFilter(NoMDT.DashboardFilterKeys.Year.key);
							} else {
								addFilter(NoMDT.DashboardFilterKeys.Year.key, filterValues, context);
							}
						} else {
							const context = path && FilterContext.fromPath(path) || new FilterContext();
							addFilter(NoMDT.DashboardFilterKeys.Year.key, filterValues, context);
						}
					}}
					placeholder={"All"}
					closeMenuOnSelect={false}
					styles={{
						placeholder: (base) => ({
							...base,
							color: "black",
						}),
					}}
				/>
			</Box>

			{(admYearSelections && admYearSelections.length == 1 ?
				<Box>
					<Typography>Admission Month</Typography>
					<Select
						isMulti={true}
						value={admMonthSelections}
						options={monthOptions}
						onChange={p => {
							const selected: any = p;
							let filterValues: string[] = [];
							selected.forEach(a => filterValues.push(a.label.substring(0, 3)));

							if (parts.length > 1) {
								let context = path && FilterContext.fromPath(path) || new FilterContext();
								context.parts = [context.parts[0]];

								if (filterValues.length == 0) {
									let context = path && FilterContext.fromPath(path) || new FilterContext();
									context.parts = [context.parts[0]];
									addFilter(NoMDT.DashboardFilterKeys.Year.key, [], context);
								} else {
									addFilter(NoMDT.DashboardFilterKeys.Year.key, filterValues, context);
								}
							} else {
								const context = path && FilterContext.fromPath(path) || new FilterContext();
								addFilter(NoMDT.DashboardFilterKeys.Year.key, filterValues, context);
							}
						}}
						placeholder={"All"}
						closeMenuOnSelect={false}
						styles={{
							placeholder: (base) => ({
								...base,
								color: "black",
							}),
						}}
					/>
				</Box>
				: null)}


			<Box>
				{(Object.keys(state.page.dashboard.filters).length !== 0 ?
					<Button
						onClick={() =>
							exportMdtPatients(noMDTData.filteredReferralIdCsv, false)
								.then(data => {
									if (data.errorMessage) {
										throw data.errorMessage;
									}

									return fileHelper.showFile(data.bytes, data.filename, fileHelper.fileTypeToMimeType(data.filetype), "exportMdtPatientsElem")
								})
								.catch(err => {
									console.log(err)
								})
						}
					>Download Patient List
					</Button> :

					<div>Make a filter selection in order to download patient list</div>)}
			</Box>

			<a id="exportMdtPatientsElem" style={{ display: "none" }}></a>
		</>
	)
}


